import { useTranslation } from 'react-i18next';
import { TikTokAdStatus } from '@anytag/graphql';
import { SelectedRangeOption } from '@anytag/shared-types';
import { SelectorField, RangeDatePickerField, TextSearchField } from '@anytag/shared-molecules';
import { Form } from '@anytag/shared-atoms';
import { AdCampaignReportFilterFormKeys } from './schemaTypes';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();

  const adCampaignStatusOptions = [
    { value: TikTokAdStatus.ENABLE, label: t('Option.Active') },
    { value: TikTokAdStatus.DISABLE, label: t('Option.Inactive') }
  ];

  return (
    <Form.Fields>
      <TextSearchField<AdCampaignReportFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.keywords')}
        css={{ flex: 1 }}
      />
      <SelectorField<AdCampaignReportFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        className="max-w-56.25"
        options={adCampaignStatusOptions}
        placeholder={t<string>('Selector.Campaign Type')}
      />
      <RangeDatePickerField<AdCampaignReportFilterFormKeys>
        onSubmit={onSubmit}
        name={{ startDate: 'startDate', endDate: 'endDate' }}
        clearable={false}
        rangeList={[
          SelectedRangeOption.TODAY,
          SelectedRangeOption.LAST_SEVEN_DAYS,
          SelectedRangeOption.TODAY_TO_MONTH_AGO,
          SelectedRangeOption.THIS_MONTH,
          SelectedRangeOption.LAST_MONTH,
          SelectedRangeOption.CUSTOM
          // SelectedRangeOption.CLEAR TODO: enable after campaignsChartForAllTime supported
        ]}
        css={{ maxWidth: '250px' }}
      />
    </Form.Fields>
  );
};
